<template>
  <v-app>
    <v-toolbar color="primary" dark fixed app>
      <v-toolbar-side-icon @click="toggleDrawer"></v-toolbar-side-icon>
      <CompanySwitcher :toggleCompanySwitcher="toggleCompanySwitcher"></CompanySwitcher>
      <v-spacer></v-spacer>
      <MyAccount is_logout="true"></MyAccount>

      <!-- <v-tooltip bottom v-if="timezone" color="white">
        <template v-slot:activator="{ on }">
          <div class="body-2 pt-1" v-on="on">
            {{ timezone }} {{ "UTC" + momentTz.tz(timezone).format("Z") }}
          </div>
        </template>
        <span class="body-1 grey--text text--darken-3">
          <b>Company Timezone.</b>
          <br />All time inputs you provide will be according to company
          configured timezone. <br />You can change it in your company setting.
        </span>
      </v-tooltip> -->
      <span class="pr-2 ">
        <b>|</b>
      </span>

      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn flat icon v-on="on" class="mx-0 px-0">
            <v-icon>mdi-earth</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-tile
            v-for="(item, index) in enabledLanguages"
            :key="index"
            @click="changeLocale(item.value)"
          >
            <v-list-tile-title
              :class="[item.value == selected_locale ? 'primary--text' : '']"
              >{{ item.text }}</v-list-tile-title
            >
          </v-list-tile>
        </v-list>
      </v-menu>

    </v-toolbar>

    <Drawer
      v-model="toolbar.drawer"
      :company_menu="company_menu"
      :account_menu="user_menu"
      :avails_manager_menu="null"
      :screener_menu="screener_menu"
      :common_menu="common_menu"
      @showCompanySwitcher="toggleCompanySwitcher = !toggleCompanySwitcher"
    />
    <v-content class="content-background">
      <router-view class="ma-3"></router-view>
    </v-content>
    <v-footer color="primary" dark fixed app>
      <v-layout class="pt-1" justify-center row wrap>
        <v-flex xs12 text-xs-center white--text>
          <span> &copy;&nbsp;{{ moment().local().format("YYYY") }} </span>
          <span>&nbsp;—&nbsp;</span>
          <span v-html="$t('rms.footer.powered_by')"></span>
          <span class="appVersion">{{
              DEFINES.APP_VERSION
            }}</span>
        </v-flex>
      </v-layout>
    </v-footer>
  </v-app>
</template>

<script>
import Drawer from "@/components/Drawer";
import CompanySwitcher from "@/components/CompanySwitcher";
import { mapFields } from "vuex-map-fields";
import { mapGetters, mapState } from "vuex";
import * as MENU from "@/menu";
import Avatar from "vue-avatar";
import DEFINES from "@/defines";
import i18n from "@/i18n";
import MyAccount from "@/components/MyAccount"

export default {
  name: "AppLayout",
  components: {
    Drawer,
    Avatar,
    CompanySwitcher,
    MyAccount
  },
  data() {
    return {
      drawer: false,
      notification_drawer: false,
      items: [
        {
          title: "Profile",
          icon: "rms_user_profile",
          route: "UserProfile",
        },
      ],
      i18n_locales: DEFINES.LOCALES,
      toggleCompanySwitcher: false
    };
  },

  computed: {
    ...mapFields("app", ["toolbar"]),
    ...mapGetters("company", {
      selectedCompanyId: "getSelected",
      isSubscriptionTrailingOrActive: "isSubscriptionTrailingOrActive",
      session_mode: "auth/getSessionMode",
      timezone: "getSelectedCompanyTimezone",
    }),
    ...mapState({
      user: (state) => state.user.profile,
      company: (state) => state.company.company,
      selected_locale: (state) => state.app.i18n_locale,
    }),
    company_menu() {
      return MENU.company(this.selectedCompanyId);
    },
    user_menu() {
      return MENU.USER(this.selectedCompanyId);
    },
    screener_menu() {
      return MENU.SCREENER(this.selectedCompanyId);
    },
    common_menu() {
      return MENU.COMMON(this.selectedCompanyId);
    },
    enabledLanguages() {
      if (this.company) {
        return ('enabled_language_support' in this.company.custom_properties) ? this.company.custom_properties.enabled_language_support : this.i18n_locale; 
      }else{
        return this.i18n_locale
      }
    }
  },
  created() {
    this.featureReleaseAlert = localStorage.getItem("featureReleaseAlert");
    // this.setUserForChatwoot()
  },
  methods: {
    toggleDrawer() {
      this.toolbar.drawer = !this.toolbar.drawer;
    },
    whereRouteNotIn(currentRouteName, ...excludedRoutes) {
      let result = true;
      for (let i = 0; i < excludedRoutes.length; i++)
        result &= currentRouteName != excludedRoutes[i];
      return result;
    },
    async changeLocale(value) {
      await this.$store.dispatch("app/updateLocale", {
        locale: value,
      });
    },
    setUserForChatwoot(){
      /**
       * 1. Set user details
       */
      window.$chatwoot.setUser(this.user.id, {
        name: this.user.name,
        email: this.user.email,
        phone_number: this.user.phone,
        company: this.company.title
      })

      /**
       * 2. Set custome properties
       */
      window.$chatwoot.setCustomAttributes({
        currentPath: this.$route.path,
      });
    }
  },
};
</script>
<style scoped>
.content-background {
  background-color: rgb(237, 246, 255) !important;
}
.remove-padding-right >>> .v-list__tile {
  padding-right: 0px !important;
}
.appVersion{
  right: 7px;
  position:absolute;
}
</style>
